'use client';
import { useEffect, useState } from 'react';

export function useIsTouchDevice(): boolean {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const hasTouchStart = 'ontouchstart' in window;
    const coarse = typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;
    const noHover = typeof window.matchMedia === 'function' && window.matchMedia('(hover: none)').matches;
    const touchPoints = typeof navigator !== 'undefined' && (navigator.maxTouchPoints ?? 0) > 0;
    setIsTouchDevice(Boolean(hasTouchStart || coarse || noHover || touchPoints));
  }, []);

  return isTouchDevice;
}
